module.exports = __webpack_public_path__ + "static/media/is.d5e1cf43.jpeg";